import { render, staticRenderFns } from "./Classificator.vue?vue&type=template&id=3e79dac6"
import script from "./Classificator.vue?vue&type=script&lang=js"
export * from "./Classificator.vue?vue&type=script&lang=js"
import style0 from "./Classificator.vue?vue&type=style&index=0&id=3e79dac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports